import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActiveApplication } from 'app/application/application';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'zest-loan-list',
  templateUrl: './loan-list.component.html',
  styleUrls: ['./loan-list.component.scss']
})
export class LoanListComponent implements OnInit {

  @Input() applications: ActiveApplication[];

  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() cancel: EventEmitter<ActiveApplication[]> = new EventEmitter<ActiveApplication[]>();
  @Output() generate: EventEmitter<ActiveApplication[]> = new EventEmitter<ActiveApplication[]>();

  s3Url = environment.s3BucketUrl;
  selectedApplications: ActiveApplication[] = [];

  constructor() { }

  ngOnInit() {
    this.selectedApplications = [...this.applications];
  }

  toggleApplicationSelection(application) {
    const selectionIndex = this.selectedApplications.indexOf(application);

    if (selectionIndex > -1) {
      this.selectedApplications.splice(selectionIndex, 1);
    } else {
      this.selectedApplications.push(application);
    }
  }

  closeView() {
    this.close.emit(true);
  }

  cancelApplications(selectedApplications) {
    this.cancel.emit(selectedApplications);
  }

  generateVouchers(selectedApplications) {
    this.generate.emit(selectedApplications);
  }

}
